import { observer } from "mobx-react"

import { useStore } from "src/store/lib/useStore"
import { KnowledgeItemStore } from "src/modals/knowledge-items/store"
import { AccessGroup } from "src/components/ModalAccessGroup/AccessGroup"

export const KnowledgeItemsAccessGroup = observer(() => {
    const store = useStore(KnowledgeItemStore)

    const handleAccessGroupChange = (accessGroupId: number) => {
        store.formFields.set("access_group_id", accessGroupId)
        store.setSelectedAccessGroupId(accessGroupId)
    }

    return (
        <AccessGroup
            accessGroupId={store.formFields.get("access_group_id")}
            errorMessage={store.formFields.error("access_group_id") ?? ""}
            disabled={store.isEditMode}
            onChange={handleAccessGroupChange}
        />
    )
})
